<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>1:1문의</h2>
                <div class="info_box">
                    <div>
                        총 게시글
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.totalLength) }}개</span>
                    </div>
                </div>
            </div>
            <div class="sch_condition_wrap">
                <div class="left">
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" @keydown.enter="searchDate" name="" id="" v-model="form_state.startDate" @change="getList" />
                        </div>
                        <div class="select_date">
                            <input
                                style="margin-left: 5px"
                                type="date"
                                @keydown.enter="searchDate"
                                name=""
                                id=""
                                v-model="form_state.endDate"
                                @change="getList"
                            />
                        </div>
                    </div>
                    <div class="select_tab_box _130">
                        <div
                            class="selected_tab"
                            :class="[state.isShowSearchType ? 'active' : '']"
                            @click="state.isShowSearchType = !state.isShowSearchType"
                        >
                            <span>{{ state.detailTxt }}</span>
                        </div>
                        <div class="tab_option">
                            <button
                                v-for="item in search_type_list"
                                @click="
                                    state.state = item.key;
                                    state.detailTxt = item.value;
                                    state.isShowSearchType = false;
                                    state.page = 1;
                                    getList();
                                "
                            >
                                {{ item.value }}
                            </button>
                        </div>
                    </div>
                    <div class="search_wrap">
                        <input
                            type="text"
                            v-model="state.searchText"
                            @keyup.enter="
                                state.page = 1;
                                getList();
                            "
                            placeholder="제목을 입력하세요."
                        />
                        <button
                            type="button"
                            class="search_btn icon_wrap"
                            @click="
                                state.page = 1;
                                getList();
                            "
                        >
                            <img src="img/search_btn.png" alt="" />
                        </button>
                    </div>
                </div>
                <div class="right">
                    <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                    <button type="button"><img src="img/excel_icon.png" @click="downloadFile" alt=" 엑셀 다운로드" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 100px" />
                        <col />
                        <col style="width: 200px" />
                        <col style="width: 200px" />
                        <col style="width: 150px" />
                        <col style="width: 200px" />
                        <col style="width: 80px" />
                        <col style="width: 60px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            </th>
                            <th>번호</th>
                            <th>제목</th>
                            <th>작성자</th>
                            <th>아이디</th>
                            <th>전화번호</th>
                            <th>작성일</th>
                            <th>답변여부</th>
                            <th>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_' + item.idx" v-model="state.checkedList" :value="item.idx" @click.stop />
                                    </label>
                                </td>
                                <td class="list_num">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td class="ellipsis_1">
                                    {{ item.title }}
                                </td>
                                <td class="ellipsis_1">{{ item.userName }}</td>
                                <td>{{ item.userId }}</td>
                                <td class="cnt">
                                    {{ CommonUtils.convertPhoneNum(item.userPhoneNum).phoneNum1 }}-{{
                                        CommonUtils.convertPhoneNum(item.userPhoneNum).phoneNum2
                                    }}-{{ CommonUtils.convertPhoneNum(item.userPhoneNum).phoneNum3 }}
                                </td>
                                <td class="cnt">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                <td>{{ item.state == 1 ? "답변" : "미답변" }}</td>
                                <td class="cnt p_5">
                                    <button v-if="item.state == 1" type="button" class="table_btn _gray" @click="isEditModal(item.idx, true)">
                                        수정
                                    </button>
                                    <button v-else type="button" class="table_btn _blue" @click="isEditModal(item.idx, false)">답변</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="9">
                                <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                :data="state.data"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <QnaModal
        v-if="state.isQnaShowModal"
        :data="state.qnaInfo"
        :isEdit="state.isEdit"
        @save="save"
        @close="state.isQnaShowModal = false"
        @callback="callBackModal"
    ></QnaModal>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        QnaModal,
        types,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        CommonUtils,
        PageBtn,
    } from "@/BaseComponent";

    export default {
        props: {},
        PageBtn,
        components: { Header, Left, ModalDefault, PageBtn, QnaModal },
        setup() {
            const global = globalStore();
            const popup = popupStore();

            const state = reactive({
                list: [] as Array<any>,
                data: {},
                qnaInfo: {},

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                searchType: "" as string,
                searchText: "" as string,
                startDate: "" as string,
                endDate: "" as string,

                isShowSearchType: false,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                state: "99" as string,
                isEdit: false as boolean,

                detailTxt: "전체" as string,
                checkAll: false as boolean,
                checkedList: [] as Array<number>,

                isQnaShowModal: false as boolean,
            });

            const form_state = reactive({
                startDate: "" as string,
                endDate: "" as string,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
            });

            onBeforeUnmount(() => {});

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                },
            );

            watch(
                () => state.searchText,
                (newVal, oldVal) => {
                    if (oldVal && newVal === "") {
                        getList();
                    }
                },
            );

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const search_type_list = [
                { id: "all", key: "99", value: "전체" },
                { id: "1", key: "1", value: "완료" },
                { id: "2", key: "0", value: "대기중" },
            ];

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqInquiryList = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,

                    state: state.state,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                const res = await apiService.inquiry.list(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const searchDate = async () => {
                if (form_state.startDate && form_state.endDate && form_state.endDate < form_state.startDate) {
                    form_state.endDate = "";
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }

                state.startDate = form_state.startDate;
                state.endDate = form_state.endDate;
                state.page = 1;
                getList();
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const param: types.ReqIdxList = {
                        idxList: state.checkedList.join(","),
                    };
                    const res = await apiService.inquiry.remove(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const isEditModal = async (idx: number, isEdit: boolean) => {
                state.isEdit = isEdit;
                if (idx != null && idx > 0 && idx != undefined) {
                    const res = await apiService.inquiry.detail(idx);
                    state.qnaInfo = res.data;
                    state.isQnaShowModal = true;
                }
            };

            const save = async (isEdit: boolean, prop: types.ReqComment) => {
                if (prop.idx != null && prop.idx > 0 && prop.idx != undefined) {
                    if (isEdit) {
                        // 수정
                        const res = await apiService.inquiry.modifyForComment(prop.idx, prop);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "수정이 완료되었습니다.";
                            state.isShowModal = true;
                            state.isQnaShowModal = false;

                            getList();
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "알림";
                            state.modalContent = "문제 발생";
                            state.isShowModal = true;
                        }
                    } else {
                        // 등록
                        if (!prop.answer) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "답변을 입력해 주세요.";
                            state.isShowModal = true;
                        } else {
                            const res = await apiService.inquiry.addForComment(prop.idx, prop);

                            if (res.returnCode === 0) {
                                state.modalTab = -1;
                                state.modalTitle = "안내";
                                state.modalContent = "답변 등록이 완료되었습니다.";
                                state.isShowModal = true;
                                state.isQnaShowModal = false;
                                getList();
                            } else {
                                state.modalTab = -1;
                                state.modalTitle = "알림";
                                state.modalContent = "문제 발생";
                                state.isShowModal = true;
                            }
                        }
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "문제 발생";
                    state.isShowModal = true;
                }
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqInquiryForExcel = {
                        searchType: state.state,
                        searchText: state.searchText,
                        startDate: state.startDate,
                        endDate: state.endDate,
                        idxList: String(state.checkedList),
                    };

                    let res = await apiService.inquiry.exportExcel(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            return {
                state,
                router,
                closeModal,
                callBackModal,
                imgError,
                types,
                global,
                popup,
                handlePageChange,
                CommonUtils,
                toggleAll,
                form_state,
                searchDate,
                isDelete,
                search_type_list,
                getList,
                isEditModal,
                save,
                downloadFile,
            };
        },
    };
</script>
<style scoped>
    .checkbox_wrap2 input[type="checkbox"] {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #fff;
        position: relative;
        vertical-align: sub;
        cursor: pointer;
        border: 1px solid #6d6d6d;
    }

    .checkbox_wrap2 em {
        display: none;
    }
</style>
